import { createSelector } from '@reduxjs/toolkit';
import { selectDevicesFields } from 'entities/device/lib';
import { select_ui_settings } from 'console/redux/settings-actions';
export const selectDevicesForMap = createSelector(selectDevicesFields(['id', 'last_gps', 'color', 'name', 'iconState']), (state) => select_ui_settings(state).map?.show_all_device_markers ?? false, (_, device_id) => device_id, (devices, show_all_device_markers, selected_device_id) => {
    if (show_all_device_markers) {
        return devices;
    }
    return devices.filter((d) => d.id === selected_device_id);
});
